export const CREATE_RENT_INSTRUMENT = "CREATE_RENT_INSTRUMENT";
export const FETCH_RENT_INSTRUMENTS = "FETCH_RENT_INSTRUMENTS";
export const FETCH_RENT_INSTRUMENT = "FETCH_RENT_INSTRUMENT";
export const EDIT_RENT_INSTRUMENT = "EDIT_RENT_INSTRUMENT";
export const DELETE_RENT_INSTRUMENT = "DELETE_RENT_INSTRUMENT";
